export const REMOTE_FEATURES = {
  //PROCESS_ANALYZER: 'process_analyzer',
  CAN_NETWORK_ANALYZER: 'can_network_analyzer',
  COMMAND_ANALYZER: 'command_analyzer',
  DEVICE_ASSESSMENT: 'custom_properties',
  ACTIVE_SCAN: 'active_scan',
  PCAP_CAPTURE: 'pcap_capture',
  FILE_INTEGRITY_ANALYZER: 'file_integrity_analyzer',
  METRIC_ANALYZER: 'metric_analyzer',
  ETH_NETWORK_ANALYZER: 'eth_network_analyzer',
  //LOG_ANALYZER: 'log_analyzer',
  MALWARE_ANALYZER: 'malware_analyzer',
  //CONFIGURATION_ANALYZER: 'configuration_analyzer',
  PACKAGE_ANALYZER: 'package_analyzer',
  //BLE_NETWORK_ANALYZER: 'ble_network_analyzer',
  FIREWALL_HANDLER: 'firewall_handler',
  PACKAGE_HANDLER: 'package_handler',
};

export const REMOTE_FEATURE_LABELS = {
  //[REMOTE_FEATURES.PROCESS_ANALYZER]: 'Process Anomaly Detection', // remove
  [REMOTE_FEATURES.COMMAND_ANALYZER]: 'Command Anomaly Detection',
  [REMOTE_FEATURES.FIREWALL_HANDLER]: 'Device Firewall', // not shown
  [REMOTE_FEATURES.PACKAGE_HANDLER]: 'Package Handler', // not shown
  [REMOTE_FEATURES.CAN_NETWORK_ANALYZER]: 'CAN Network Anomaly Detection',
  [REMOTE_FEATURES.METRIC_ANALYZER]: 'Metric Anomaly Detection',
  //[REMOTE_FEATURES.LOG_ANALYZER]: 'Log Anomaly Detection', // remove
  //[REMOTE_FEATURES.MALWARE_ANALYZER]: 'Malware Detection', // remove
  //[REMOTE_FEATURES.CONFIGURATION_ANALYZER]: 'Configuration Anomaly Detection', // remove
  [REMOTE_FEATURES.PACKAGE_ANALYZER]: 'Package Anomaly Detection',
  //[REMOTE_FEATURES.BLE_NETWORK_ANALYZER]: 'BLE Network Anomaly Detection', // remove
  [REMOTE_FEATURES.ACTIVE_SCAN]: 'Ethernet Active Scan',
  [REMOTE_FEATURES.DEVICE_ASSESSMENT]: 'Device Assessment',
  [REMOTE_FEATURES.FILE_INTEGRITY_ANALYZER]: 'File Integrity Anomaly Detection',
  [REMOTE_FEATURES.PCAP_CAPTURE]: 'Ethernet PCAP Capture',
  [REMOTE_FEATURES.ETH_NETWORK_ANALYZER]: 'Ethernet Anomaly Detection',
};
